import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";

export default function InsuranceDetail() {
  const { artworkId } = useParams();
  const [insurance, setInsurance] = useState(null);
  const [artwork, setArtwork] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchInsurance = async () => {
      setIsLoading(true);
      try {
        const { data: artworkData } = await supabase
          .from("artworks")
          .select("id, title, artist, year, value")
          .eq("id", artworkId)
          .single();

        const { data: insuranceData } = await supabase
          .from("insurance")
          .select("*")
          .eq("artwork_id", artworkId)
          .single();

        setArtwork(artworkData);
        setInsurance(insuranceData);
      } catch (error) {
        console.error("Erreur chargement assurance:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInsurance();
  }, [artworkId]);

  if (isLoading) {
    return <div className="p-6">Chargement...</div>;
  }

  if (!artwork) {
    return <div className="p-6 text-red-600">Œuvre non trouvée</div>;
  }

  return (
    <div className="max-w-4xl mx-auto px-6 py-10">
      <h1 className="text-2xl font-bold mb-4">Assurance : {artwork.title}</h1>

      {insurance ? (
        <div className="border rounded-md p-6 bg-gray-50">
          <p><strong>Assureur :</strong> {insurance.insurer}</p>
          <p><strong>Type :</strong> {insurance.insurance_type}</p>
          <p><strong>Valeur assurée :</strong> {insurance.value} €</p>
          <p><strong>Expiration :</strong> {insurance.expiry_date ? new Date(insurance.expiry_date).toLocaleDateString() : "Non spécifiée"}</p>
        </div>
      ) : (
        <div className="p-6 border rounded bg-yellow-50 text-yellow-800">
          Aucune assurance n'est encore associée à cette œuvre.
          <div className="mt-2 text-sm text-yellow-900">
            Vous pouvez solliciter un partenaire assureur spécialisé pour analyser votre situation.
            Aucune souscription n’est engagée à ce stade.
          </div>
          <div className="mt-4">
            <Link
              to="/insurance"
              state={{ preselectArtworkId: artwork.id }}
              className="btn-artsy btn-primary-artsy"
            >
              Ajouter une couverture
            </Link>
          </div>
        </div>
      )}

      <div className="mt-6">
        <Link to={`/artwork/${artworkId}`} className="text-blue-600 underline">
          ← Retour à la fiche œuvre
        </Link>
      </div>
    </div>
  );
}
